import React from 'react';
import './Button.scss';

interface ButtonProps {
    width?: string;
    children?: React.ReactNode;
    onClick: () => void;
    background?: string;
    className?: string;
    disabled?: boolean;
    id?: string;
}

const Button = ({
                    width = "fit-content",
                    children,
                    onClick,
                    background = "transparent",
                    className = "",
                    disabled = false,
                    id
                }: ButtonProps) => (
    <button
        className={`Button ${className}`}
        id={id}
        disabled={disabled}
        onClick={onClick}
        style={{ width, background }}
    >
        {children}
    </button>
);

export default Button;